import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import { Dialog } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { Dispatch, ReactElement, SetStateAction } from "react";
import COLORS from "../../../../theme/Colors";
import { ModalBody, ModalTitle } from "./styles/RequestStatusModalStyles";
interface Props {
  message: {
    variant: "success" | "error";
    content: string;
  };
  showDialogModal: boolean;
  setShowDialogModal: Dispatch<SetStateAction<boolean>>;
}

const RequestStatusModal = ({
  showDialogModal,
  setShowDialogModal,
  message,
}: Props): ReactElement => {
  return (
    <Dialog open={showDialogModal}>
      <IconButton
        sx={{ alignSelf: "flex-end", padding: "16px" }}
        aria-label="close"
        onClick={() => setShowDialogModal(false)}
      >
        <CloseIcon sx={{ color: COLORS.primary }} />
      </IconButton>

      <ModalBody>
        {message?.variant === "error" ? (
          <ErrorIcon
            fontSize="large"
            sx={{ color: COLORS.error, fontSize: "10rem" }}
          />
        ) : (
          <CheckCircleIcon
            fontSize="large"
            sx={{ color: COLORS.success, fontSize: "10rem" }}
          />
        )}
        <ModalTitle>{message?.content}</ModalTitle>
      </ModalBody>
    </Dialog>
  );
};
export default RequestStatusModal;
